import type { ComponentProps } from "react"
import type { LucideIcon } from "lucide-react"
import { cn } from "@/shadcn/lib/utils"

export type IconSize = "sm" | "md" | "lg"

export type IconProps = {
  icon: LucideIcon
  size?: IconSize
} & Omit<ComponentProps<"svg">, "children">

const iconSizeClasses: Record<IconSize, string> = {
  sm: "size-4",
  md: "size-5",
  lg: "size-6",
}

export function Icon({ icon: IconComponent, size = "md", className, ...props }: IconProps) {
  return (
    <IconComponent
      className={cn(
        iconSizeClasses[size],
        "shrink-0 focus:border-transparent focus:ring-0 focus:outline-none",
        className
      )}
      {...props}
    />
  )
}
